import { render } from "./ReportPlatformSales.vue?vue&type=template&id=03fd9e3d&scoped=true"
import script from "./ReportPlatformSales.vue?vue&type=script&lang=js"
export * from "./ReportPlatformSales.vue?vue&type=script&lang=js"

import "./ReportPlatformSales.vue?vue&type=style&index=0&id=03fd9e3d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03fd9e3d"]])

export default __exports__